var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertisericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#6661FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6154 17.594V26.7135C32.6158 26.9564 32.5583 27.196 32.4475 27.4143C32.3366 27.6326 32.1752 27.8237 31.9757 27.973C31.6819 28.188 31.3232 28.3056 30.9538 28.3079C30.8193 28.3075 30.6854 28.2914 30.555 28.26L22.6458 26.3628L21.7153 26.1396H20.1534C19.066 26.1394 18.022 25.7301 17.2456 24.9996C16.6565 24.4454 16.2528 23.7354 16.0859 22.9602C15.919 22.185 15.9964 21.3796 16.3084 20.6468C16.6203 19.9139 17.1525 19.2868 17.8373 18.8453C18.5221 18.4039 19.3284 18.168 20.1534 18.1679H21.7153L30.555 16.0475C30.799 15.989 31.0536 15.9845 31.2997 16.0342C31.5458 16.0839 31.7769 16.1866 31.9757 16.3344C32.1752 16.4838 32.3366 16.6749 32.4475 16.8932C32.5583 17.1114 32.6158 17.3511 32.6154 17.594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7668 27.4453V30.3985C22.7668 30.823 22.5995 31.2302 22.3017 31.5304C22.0039 31.8305 21.5999 31.9992 21.1787 31.9992H20.2418C19.8691 32.0064 19.5058 31.8812 19.2155 31.6457C18.9252 31.4101 18.7263 31.0791 18.6537 30.7107L17.8438 26.4609C18.2682 26.7348 18.7352 26.935 19.2254 27.0532C19.6043 27.1498 19.9938 27.1982 20.3847 27.1972H21.7822L22.7668 27.4453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertisericon);
export default __webpack_public_path__ + "static/media/advertisericon.3a122011f7112b732174b030aee47181.svg";
export { ForwardRef as ReactComponent };